import React from 'react';

import {
  Actions as UIActions,
  Action,
  DoneIcon,
  PendingActionsIcon,
  NotInterestedIcon,
  InfoIcon,
  EditIcon,
  DeleteIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

export const Actions = ({
  actions,
  hasComments,
  withViewLog,
  onViewLog,
  onApprove,
  onAddComment,
  onAddAmendment,
  onMoreInfo,
  onReject,
  onTerminate,
  onUndo,
  onSignByPartner,
  onMarkAsAgreement,
  onEdit,
  onDelete,
  onResend,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions limit={3}>
          <Action
            id={'approve'}
            icon={<DoneIcon />}
            label={'Approve'}
            disabled={!isActionAllowed('Approve')}
            onClick={onApprove}
          />
          {withViewLog ? (
            <Action
              id={'view_log'}
              icon={<PendingActionsIcon />}
              label={'View log'}
              badge={hasComments}
              onClick={onViewLog}
            />
          ) : null}
          <Action
            id={'reject'}
            icon={<NotInterestedIcon />}
            label={'Reject'}
            disabled={!isActionAllowed('Reject')}
            onClick={onReject}
          />
          <Action
            id={'more_info'}
            icon={<InfoIcon />}
            label={'Request more info'}
            disabled={!isActionAllowed('RequestMoreInfo')}
            onClick={onMoreInfo}
          />
          {isActionAllowed('Undo') && (
            <Action>
              <Action id={'undo'} label={'Undo'} onClick={onUndo} />
            </Action>
          )}

          <Action>
            <Action
              id={'addComment'}
              label={'Add comment'}
              disabled={!isActionAllowed('Comment')}
              onClick={onAddComment}
            />
            <Action
              id={'add_amendment'}
              label={'Add Amendment'}
              disabled={!isActionAllowed('AddAmendment')}
              onClick={onAddAmendment}
            />
          </Action>
          <Action>
            <Action
              id={'sign_by_partner'}
              label={'Mark as "Signed"'}
              disabled={!isActionAllowed('SignByPartner')}
              onClick={onSignByPartner}
            />
            <Action
              id={'mark_no_changes'}
              label={'Mark as "No Changes"'}
              disabled={!isActionAllowed('MarkNoChanges')}
              onClick={onMarkAsAgreement}
            />
          </Action>
          <Action>
            <Action
              id={'terminate'}
              label={'Terminate'}
              disabled={!isActionAllowed('Terminate')}
              onClick={onTerminate}
            />
            <Action
              id={'resend'}
              label={'Re-send IO to the partner'}
              onClick={onResend}
              disabled={!isActionAllowed('Resend')}
            />
          </Action>
          <Action>
            <Action
              id={'edit'}
              icon={<EditIcon />}
              label={'Edit'}
              disabled={!isActionAllowed('Edit')}
              onClick={onEdit}
            />
            <Action
              id={'delete'}
              icon={<DeleteIcon />}
              label={'Delete'}
              disabled={!isActionAllowed('Delete')}
              onClick={onDelete}
            />
          </Action>
        </UIActions>
      )}
    </Permissions>
  );
};

export default Actions;
